import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import DeveloperPortfolio from '../templates/DeveloperPortfolio';
import DeveloperPortfolioNew from '../templates/DeveloperPortfolioNew';
import TylerDurden from '../templates/TylerDurden';

const publicImage = (path) => `${process.env.PUBLIC_URL}${path}`;

const characterProfiles = {
  jon: {
    characterKey: 'jon',
    template: 'developer',
    proImgUrl: publicImage('/images/jonsnow.png'),
    tagline: 'Guardian of the North',
    heroHeading: "Hi, I'm Jon Snow – I ship fearless digital experiences.",
    heroSubHeading:
      'I lead high-stakes product launches with calm precision, blending battle-tested leadership with modern engineering craft.',
    socials: {
      facebookUrl: 'https://facebook.com/jonsnow',
      xUrl: 'https://x.com/jonsnow',
      InstaUrl: 'https://instagram.com/jonsnow',
      LinkUrl: 'https://www.linkedin.com/in/jonsnow',
      GithubUrl: 'https://github.com/jonsnow',
      DribbleUrl: 'https://dribbble.com/jonsnow',
      BehanceUrl: 'https://behance.net/jonsnow',
      resume: '#',
    },
    skills: [
      { value: 'React', label: 'React', icon: publicImage('/images/icons/React.svg') },
      { value: 'TypeScript', label: 'TypeScript', icon: publicImage('/images/icons/TypeScript.svg') },
      { value: 'Node.js', label: 'Node.js', icon: publicImage('/images/icons/node.svg') },
      { value: 'AWS', label: 'AWS', icon: publicImage('/images/icons/AWS.svg') },
    ],
    experiences: [
      {
        company: "Night's Watch Digital",
        role: 'Lead Platform Engineer',
        from: '2019-01-01',
        to: '2022-12-31',
      },
      {
        company: 'Winterfell Labs',
        role: 'Head of Product',
        from: '2023-01-01',
        to: '2024-12-31',
      },
    ],
    userProjects: [
      {
        projectName: 'Dragonglass CRM',
        projectLink: 'https://dragonglass.app',
        projectImage: publicImage('/images/site2.png'),
        previewImage: publicImage('/images/site2.png'),
      },
      {
        projectName: 'Raven Realtime',
        projectLink: 'https://ravenrealtime.dev',
        projectImage: publicImage('/images/site3.png'),
        previewImage: publicImage('/images/site3.png'),
      },
    ],
  },
  arya: {
    characterKey: 'arya',
    template: 'tyler',
    proImgUrl: publicImage('/images/arya.jpeg'),
    tagline: 'Faceless Product Slayer',
    heroHeading: "I'm Arya Stark — stealthy design, ruthless execution.",
    heroSubHeading:
      'I thread pixel-perfect experiences through complex stacks, wearing many faces until the job is done.',
    socials: {
      facebookUrl: 'https://facebook.com/arya',
      xUrl: 'https://x.com/noone',
      InstaUrl: 'https://instagram.com/needlecraft',
      LinkUrl: 'https://www.linkedin.com/in/arya',
      GithubUrl: 'https://github.com/valarmorghulis',
      DribbleUrl: 'https://dribbble.com/needle',
      BehanceUrl: 'https://behance.net/arya',
      resume: '#',
    },
    skills: [
      { value: 'Next.js', label: 'Next.js', icon: publicImage('/images/icons/nextjs.svg') },
      { value: 'Tailwind CSS', label: 'Tailwind CSS', icon: publicImage('/images/icons/Tailwind-CSS.svg') },
      { value: 'GraphQL', label: 'GraphQL', icon: publicImage('/images/icons/React.svg') },
      { value: 'Figma', label: 'Figma', icon: publicImage('/images/icons/Figma.svg') },
    ],
    experiences: [
      {
        company: 'Faceless Labs',
        role: 'Lead Experience Engineer',
        from: '2020-02-01',
        to: '2023-07-01',
      },
      {
        company: 'Needle Commerce',
        role: 'Creative Technologist',
        from: '2023-07-01',
        to: '2025-01-01',
      },
    ],
    userProjects: [
      {
        projectName: 'Needle Marketplace',
        projectLink: 'https://needle.market',
        projectImage: publicImage('/images/site.png'),
        previewImage: publicImage('/images/site.png'),
      },
      {
        projectName: 'Faces UI Kit',
        projectLink: 'https://faces.design',
        projectImage: publicImage('/images/site2.png'),
        previewImage: publicImage('/images/site2.png'),
      },
    ],
  },
  hound: {
    characterKey: 'hound',
    template: 'developer',
    proImgUrl: publicImage('/images/hound.jpeg'),
    tagline: 'Battle-Tested Ops General',
    heroHeading: "Sandor Clegane here — I harden products the brutal way.",
    heroSubHeading:
      'From on-call infernos to zero-downtime launches, I protect platforms with ruthless pragmatism.',
    socials: {
      facebookUrl: 'https://facebook.com/houndops',
      xUrl: 'https://x.com/houndops',
      InstaUrl: 'https://instagram.com/houndops',
      LinkUrl: 'https://www.linkedin.com/in/houndops',
      GithubUrl: 'https://github.com/houndops',
      DribbleUrl: 'https://dribbble.com/houndops',
      BehanceUrl: 'https://behance.net/houndops',
      resume: '#',
    },
    skills: [
      { value: 'AWS', label: 'AWS', icon: publicImage('/images/icons/AWS.svg') },
      { value: 'Docker', label: 'Docker', icon: publicImage('/images/icons/Docker.svg') },
      { value: 'Kubernetes', label: 'Kubernetes', icon: publicImage('/images/icons/Kubernetes.svg') },
      { value: 'Go', label: 'Go', icon: publicImage('/images/icons/Go.svg') },
    ],
    experiences: [
      {
        company: 'Citadel Cloud',
        role: 'Senior DevOps Engineer',
        from: '2018-03-01',
        to: '2021-10-01',
      },
      {
        company: 'Kingsroad Systems',
        role: 'Director of Site Reliability',
        from: '2021-11-01',
        to: '2025-01-01',
      },
    ],
    userProjects: [
      {
        projectName: 'ShieldWall Observability',
        projectLink: 'https://shieldwall.dev',
        projectImage: publicImage('/images/site3.png'),
        previewImage: publicImage('/images/site3.png'),
      },
      {
        projectName: 'Anvil Deploy',
        projectLink: 'https://anvildeploy.com',
        projectImage: publicImage('/images/folio.png'),
        previewImage: publicImage('/images/folio.png'),
      },
    ],
  },
  tyrion: {
    characterKey: 'tyrion',
    template: 'developer',
    proImgUrl: publicImage('/images/tyrion.png'),
    tagline: 'Strategist & Storyteller',
    heroHeading: "I'm Tyrion Lannister — I turn data into disarming narratives.",
    heroSubHeading:
      'Whether pitching investors or crafting dashboards, I pair sharp analytics with sharper wit.',
    socials: {
      facebookUrl: 'https://facebook.com/tyrion',
      xUrl: 'https://x.com/imptech',
      InstaUrl: 'https://instagram.com/imptech',
      LinkUrl: 'https://www.linkedin.com/in/tyrion',
      GithubUrl: 'https://github.com/imptech',
      DribbleUrl: 'https://dribbble.com/imptech',
      BehanceUrl: 'https://behance.net/imptech',
      resume: '#',
    },
    skills: [
      { value: 'Python', label: 'Python', icon: publicImage('/images/icons/Python.svg') },
      { value: 'SQL', label: 'SQL', icon: publicImage('/images/icons/PostgresSQL.svg') },
      { value: 'Power BI', label: 'Power BI', icon: publicImage('/images/icons/HTML5.svg') },
      { value: 'Storytelling', label: 'Storytelling', icon: publicImage('/images/icons/HTML5.svg') },
    ],
    experiences: [
      {
        company: 'Hand of the Product',
        role: 'Chief Strategy Officer',
        from: '2017-05-01',
        to: '2022-08-01',
      },
      {
        company: 'Casterly Analytics',
        role: 'Principal Consultant',
        from: '2022-08-01',
        to: '2025-01-01',
      },
    ],
    userProjects: [
      {
        projectName: 'Small Council Metrics',
        projectLink: 'https://smallcouncil.xyz',
        projectImage: publicImage('/images/probg.png'),
        previewImage: publicImage('/images/probg.png'),
      },
      {
        projectName: 'Wine Ledger',
        projectLink: 'https://wineledger.app',
        projectImage: publicImage('/images/site.png'),
        previewImage: publicImage('/images/site.png'),
      },
    ],
  },
};

const buildLandingData = (profile) => ({
  proImgUrl: profile.proImgUrl,
  tagline: profile.tagline,
  heroHeading: profile.heroHeading,
  heroSubHeading: profile.heroSubHeading,
  facebookUrl: profile.socials.facebookUrl,
  xUrl: profile.socials.xUrl,
  InstaUrl: profile.socials.InstaUrl,
  LinkUrl: profile.socials.LinkUrl,
  GithubUrl: profile.socials.GithubUrl,
  DribbleUrl: profile.socials.DribbleUrl,
  BehanceUrl: profile.socials.BehanceUrl,
  resume: profile.socials.resume,
  skills: profile.skills,
  experiences: profile.experiences,
  userProjects: profile.userProjects,
});

const previewTemplateMap = {
  default: {
    component: DeveloperPortfolioNew,
    templateKey: 'developer',
    characterKey: 'jon',
  },
  'tyler-durden': {
    component: DeveloperPortfolio,
    templateKey: 'tyler',
    characterKey: 'arya',
  },
  'real-estate': {
    component: DeveloperPortfolioNew,
    templateKey: 'developer',
    characterKey: 'hound',
  },
  doctor: {
    component: DeveloperPortfolioNew,
    templateKey: 'developer',
    characterKey: 'tyrion',
  },
  clinic: {
    component: DeveloperPortfolioNew,
    templateKey: 'developer',
    characterKey: 'jon',
  },
};

const TemplatePreview = () => {
  const { templateId } = useParams();
  const config = previewTemplateMap[templateId];

  if (!config) {
    return <Navigate to="/404" />;
  }

  const TemplateComponent = config.component;
  const profile = characterProfiles[config.characterKey] || characterProfiles.jon;

  const previewData = {
    project: {
      template: config.templateKey,
      projectName: `preview-${profile.characterKey}`,
      landingPageData: buildLandingData(profile),
    },
  };

  return <TemplateComponent previewData={previewData} />;
};

export default TemplatePreview;

